document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const navbar = document.querySelector('.navbar');
  const navLinks = document.querySelector('.nav-links');

  if (menuToggle && navbar && navLinks) {
    menuToggle.addEventListener('click', () => {
      const open = navbar.classList.toggle('menu-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('.product-thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const main = thumb.closest('.product-gallery')?.querySelector('img[itemprop="image"], .product-gallery > img');
      const src = thumb.getAttribute('data-src');
      if (main && src) main.src = src;
    });
  });
});
